export const ROUTE_ENTRY_QUERY_KEY = 'entry';

export const ROUTE_ENTRY_VALUES = {
  autopilotWorkspace: 'workspace',
  diagnosis: 'diagnosis',
  cloneMigration: 'clone',
  domainHelp: 'domain-help',
} as const;

export const HELP_ARTICLE_QUERY_KEY = 'article';
export const AUTOPILOT_CLONE_DIALOG_QUERY_KEY = 'cloneDialog';
export const AUTOPILOT_CLONE_PAGE_ID_QUERY_KEY = 'clonePageId';
export const AUTOPILOT_CLONE_PAGE_URL_QUERY_KEY = 'clonePageUrl';
export const DOMAIN_HELP_ARTICLE_ID = 'article-publish';
export const STUDIO_SETTINGS_QUERY_KEY = 'settings';
export const STUDIO_SETTINGS_TAB_QUERY_KEY = 'settingsTab';

export const STUDIO_SETTINGS_VALUES = {
  page: 'page',
} as const;

export const STUDIO_SETTINGS_TAB_VALUES = {
  domain: 'domain',
  gads: 'gads',
  metadata: 'seo',
  analytics: 'analytics',
} as const;

export const isRouteEntry = (value: string | null | undefined, entry: string) =>
  (value || '').trim().toLowerCase() === entry;
